import { useCallback, useRef } from "react";
import { MapView } from "@/components/Map";
import { useLocale } from "@/contexts/LocaleContext";

interface PropertyLocationMapProps {
  postalCode: string;
  city: string;
}

/** Zeigt bewusst nur den PLZ-Bereich, nie Straße oder Hausnummer. */
export default function PropertyLocationMap({ postalCode, city }: PropertyLocationMapProps) {
  const { t } = useLocale();
  const markerRef = useRef<google.maps.marker.AdvancedMarkerElement | null>(null);
  const area = `${postalCode} ${city}`.trim();

  const handleMapReady = useCallback((map: google.maps.Map) => {
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ address: `${area}, Deutschland` }, (results, status) => {
      if (status !== "OK" || !results?.[0]) return;
      const location = results[0].geometry.location;
      map.setCenter(location);
      map.setZoom(13);
      markerRef.current?.map && (markerRef.current.map = null);
      markerRef.current = new google.maps.marker.AdvancedMarkerElement({
        map,
        position: location,
        title: t("areaByPostalCode"),
      });
    });
  }, [area, t]);

  return (
    <section className="mb-8" aria-labelledby="property-location-heading">
      <h2 id="property-location-heading" className="text-lg font-bold text-[#2d1b4e] mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
        {t("areaByPostalCode")} {area}
      </h2>
      <p className="text-sm text-[#6b5b7e] mb-3">{t("privacyLocationHint")}</p>
      <div className="overflow-hidden rounded-2xl border border-[#e8dff0] bg-white shadow-sm">
        <MapView
          className="h-[280px] sm:h-[340px]"
          initialCenter={{ lat: 49.07, lng: 9.0 }}
          initialZoom={10}
          onMapReady={handleMapReady}
        />
      </div>
    </section>
  );
}
